import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHomeHLine = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M7.00594 1.4863C7.65303 1.28419 8.34638 1.28419 8.99347 1.4863C9.3997 1.61318 9.75062 1.83702 10.1137 2.12899C10.4657 2.4121 10.8685 2.79249 11.367 3.26326L13.1779 4.97356C13.6155 5.38664 13.9184 5.67254 14.1398 6.01806C14.3354 6.32335 14.4798 6.65849 14.5675 7.0103C14.6667 7.40847 14.6666 7.82498 14.6664 8.42677L14.6664 9.76196C14.6664 10.4844 14.6664 11.0673 14.6278 11.5392C14.5881 12.0251 14.5043 12.4518 14.3031 12.8467C13.9835 13.4739 13.4735 13.9839 12.8463 14.3034C12.4515 14.5046 12.0247 14.5885 11.5388 14.6282C11.0669 14.6668 10.4841 14.6667 9.76166 14.6667H6.23782C5.51533 14.6667 4.93252 14.6668 4.46062 14.6282C3.97472 14.5885 3.54793 14.5046 3.15307 14.3034C2.52586 13.9839 2.01593 13.4739 1.69635 12.8467C1.49516 12.4518 1.41128 12.0251 1.37158 11.5392C1.33303 11.0672 1.33303 10.4845 1.33304 9.76195L1.33302 8.42679C1.33284 7.82499 1.33272 7.40847 1.43193 7.0103C1.51958 6.6585 1.66405 6.32335 1.85963 6.01806C2.08098 5.67254 2.38388 5.38664 2.82152 4.97356L4.63245 3.26327C5.1309 2.79249 5.53366 2.4121 5.88571 2.12899C6.24879 1.83702 6.5997 1.61318 7.00594 1.4863Z",
		stroke: "#111827",
		strokeWidth: 1.33333,
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M6 11.333H10",
		stroke: "#111827",
		strokeWidth: 1.33333,
		strokeLinecap: "round"
	})]
});
const ForwardRef = forwardRef(SvgHomeHLine);
export default ForwardRef;
